<template>
  <div class="post-description">
    <div class="content">
      <Like @toggleLike="toggleLike" :liked="liked" v-if="enable_likes" />
      <SocialShare v-if="showSocialShare" :sharing="{ url: shareUrl }" />
      <Options />
    </div>
  </div>
</template>

<script>
import SocialShare from "../../CallToAction/SocialShare";
import Like from "../../CallToAction/Like";
import Options from "../Button/Options.vue";

import resources from "../../../resources.js";

const SHOW_SOCIAL_SHARE = process.env.VUE_APP_ENABLE_SSR_LINK === "true";

export default {
  name: "PostPreviewDescription",
  components: {
    SocialShare,
    Like,
    Options
},
  props: {
    post: {},
    model: {},
  },
  data() {
    return {
      shareUrl: `${document.location.origin}/@${this.model.username}/post/${this.post.post_id}`,
      showSocialShare: SHOW_SOCIAL_SHARE,
    };
  },
  methods: {
    toggleLike(value) {
      if (Object.keys(this.post) == 0 || Object.keys(this.model) == 0) return;

      resources.postLike.toggleLike({ postID: this.post.post_id });
    },
  },
  computed: {
    liked() {
      return this.post.interaction.liked;
    },
    enable_likes() {
      return this.post.interaction && this.post.interaction.likes_enabled;
    },
  }
};
</script>
<style lang="scss" scoped>
@import "../../../styles/variables";

.post-description {
  margin-inline: 5px;
  margin-block: 5px 10px;
  text-align: left;
  // min-height: 50px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-evenly;
    -webkit-box-direction: normal;

    width: 100%;
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;

    > * {
      margin-inline: 7.5px;
    }
  }
}
</style>
